/**
 * 전략 비교 탭 구성
 */
import { Dispatch, SetStateAction } from 'react';
import { SectionCard } from '../common/SectionCard';
import { ComparisonResponse } from '../../services/backtestApi';
import ComparisonTable from './ComparisonTable';

interface BacktestComparisonTabProps {
  symbol: string;
  onSymbolChange: Dispatch<SetStateAction<string>>;
  period: '3M' | '6M' | '1Y';
  onPeriodChange: Dispatch<SetStateAction<'3M' | '6M' | '1Y'>>;
  loading: boolean;
  result: ComparisonResponse | null;
  onCompare: () => void;
}

export default function BacktestComparisonTab({
  symbol,
  onSymbolChange,
  period,
  onPeriodChange,
  loading,
  result,
  onCompare,
}: BacktestComparisonTabProps) {
  return (
    <div className="backtest-section-stack">
      <SectionCard
        title="종목별 전략 비교"
        subtitle={`${symbol || '종목'} · 전체 전략 · ${period}`}
      >
        <div className="backtest-form">
          <label>
            종목
            <input
              type="text"
              value={symbol}
              onChange={(event) => onSymbolChange(event.target.value.toUpperCase())}
              placeholder="AAPL"
            />
          </label>

          <label>
            기간
            <select
              value={period}
              onChange={(event) =>
                onPeriodChange(event.target.value as '3M' | '6M' | '1Y')
              }
            >
              <option value="3M">3개월</option>
              <option value="6M">6개월</option>
              <option value="1Y">1년</option>
            </select>
          </label>
        </div>

        <button
          onClick={onCompare}
          disabled={loading}
          className="backtest-run-btn"
        >
          {loading ? '분석 중...' : '전략 비교 실행'}
        </button>
      </SectionCard>

      {result && (
        <>
          <SectionCard
            title="최우수 전략"
            subtitle={`${result.symbol} · ${result.period} · ${result.best_strategy.strategy}`}
          >
            <div className="backtest-metric positive best-strategy-metric">
              <p className="backtest-metric-label">총 수익률</p>
              <strong className="backtest-metric-value">
                {result.best_strategy.return.toFixed(2)}%
              </strong>
            </div>
          </SectionCard>

          <ComparisonTable results={result.results} />
        </>
      )}
    </div>
  );
}
